var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { api } from './baseApi';
export var eventsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getEvents: builder.query({
                query: function () {
                    return ({
                        url: '/events',
                        method: 'GET',
                    });
                },
                providesTags: ['Events'],
            }),
            getEventsPublic: builder.query({
                query: function (params) {
                    return ({
                        url: '/events/public',
                        method: 'GET',
                        params: params || {},
                    });
                },
                providesTags: ['Events'],
            }),
            getEventById: builder.query({
                query: function (id) {
                    return ({
                        url: "/events/".concat(id),
                        method: 'GET',
                    });
                },
                providesTags: ['Events'],
            }),
            createEvent: builder.mutation({
                query: function (_a) {
                    var data = _a.data, files = _a.files;
                    var formData = new FormData();
                    // Добавляем данные события
                    Object.keys(data).forEach(function (key) {
                        if (data[key] !== undefined) {
                            formData.append(key, String(data[key]));
                        }
                    });
                    // Добавляем файлы
                    if (files && files.length > 0) {
                        files.forEach(function (file) {
                            formData.append('files', file);
                        });
                    }
                    return {
                        method: 'POST',
                        url: '/events',
                        body: formData,
                    };
                },
                invalidatesTags: ['Events'],
            }),
            updateEvent: builder.mutation({
                query: function (_a) {
                    var id = _a.id, body = __rest(_a, ["id"]);
                    return ({
                        method: 'PATCH',
                        url: "/events/".concat(id),
                        body: body,
                    });
                },
                invalidatesTags: ['Events'],
            }),
            setPinned: builder.mutation({
                query: function (id) {
                    return ({
                        method: 'PATCH',
                        url: "/events/".concat(id, "/pin"),
                    });
                },
                invalidatesTags: ['Events'],
            }),
            setEventPinned: builder.mutation({
                query: function (id) {
                    return ({
                        method: 'PATCH',
                        url: "/events/".concat(id, "/pin"),
                    });
                },
                invalidatesTags: ['Events'],
            }),
            deleteEvent: builder.mutation({
                query: function (id) {
                    return ({
                        method: 'DELETE',
                        url: "/events/".concat(id),
                    });
                },
                invalidatesTags: ['Events'],
            }),
        });
    },
});
export var useGetEventsQuery = eventsApi.useGetEventsQuery, useGetEventsPublicQuery = eventsApi.useGetEventsPublicQuery, useGetEventByIdQuery = eventsApi.useGetEventByIdQuery, useCreateEventMutation = eventsApi.useCreateEventMutation, useUpdateEventMutation = eventsApi.useUpdateEventMutation, useDeleteEventMutation = eventsApi.useDeleteEventMutation, useSetPinnedMutation = eventsApi.useSetPinnedMutation, useSetEventPinnedMutation = eventsApi.useSetEventPinnedMutation;
